<div class="blog-sidebar-area ml-20">
  <div class="blog-sidebar-item mt-30">
      <div class="sidebar-title">
          <h4 class="title">IPRES -	Les obligations</h4>
      </div>
      <div class="sidebar-feeds mt-45">
        L'employeur ou adhérent est responsable de l'adhésion de son entreprise et de la déclaration de son personnel à l'IPRES. L'employeur a l'obligation du paiement, à l'IPRES, des cotisations patronales et des cotisations salariales retenues sur la rémunération de ses salariés. Il doit produire les déclarations annuelles de salaires au plus tard le 31 mars de l'année qui suit, l'entreprise doit retourner à l'IPRES les états de déclaration du personnel et des salaires. Ces états permettent
        <br>•	de renseigner sur les mouvements de son personnel (entrée et sortie) <br>
        •	d'immatriculer les nouvelles embauches ;<br>
        •	et d'alimenter les comptes participants

      </div>
  </div>
    <div class="blog-sidebar-item mt-30">
        <div class="sidebar-title">
            <h4 class="title">IPRES - Le plafond des cotisations</h4>
        </div>
        <div class="sidebar-about-contnent text-center mt-35">
            <p>Depuis le 1er janvier 2017 le plafond de salaire soumis à la cotisation est le suivant :</p>
            <b>Régime Général</b> <br>
           <ol>
              <li>Le plafond mensuel passe de 300 000 à 360 000FCFA</li>
              <li>Le plafond annuel passe de 3 468 000 à 4 320 000FCFA</li>
            </ol>
            <br><br>
            <b>Régime Complémentaire Cadre</b> <br>
           <ol>
              <li>Le plafond mensuel passe de 900 000 à 1 080 000FCFA</li>
              <li>Le plafond annuel passe de 10 404 000 à 12 960 000FCFA</li>
            </ol>


        </div>
    </div>
    <div class="blog-sidebar-item mt-30">
        <div class="sidebar-title">
            <h4 class="title">IPRES - Le taux des cotisations</h4>
        </div>
        <div class="sidebar-search-item text-center mt-35">
          <div class="sidebar-about-contnent text-center mt-35">
              <p>Les cotisations sont également fonction du taux d'appel des cotisations égal, depuis Avril 1994, à14% au régime général et 6% au régime complémentaire des cadres, à raison :</p>
             <ol>
                <li>de 60% pour la part employeur (8,4% au RGR et 3,6% au RCC) ;</li>
                <li>et 40% pour la part employé (5,6% au RGR et 2,4% au RCC).</li>
              </ol>
          </div>
        </div>
    </div>

    <!-- <div class="blog-sidebar-item mt-30">
        <div class="sidebar-title">
            <h4 class="title">Categories</h4>
        </div>
        <div class="sidebar-categories mt-35">
            <ul>
                <li><a routerLink='/blog-detail'>Business<span>26</span></a></li>
                <li><a routerLink='/blog-detail'>Consultant<span>30</span></a></li>
                <li><a routerLink='/blog-detail'>Creative<span>71</span></a></li>
                <li><a routerLink='/blog-detail'>UI/UX<span>56</span></a></li>
                <li><a routerLink='/blog-detail'>Technology<span>60</span></a></li>
            </ul>
        </div>
    </div> -->
    <!-- <div class="blog-sidebar-item mt-30">
        <div class="sidebar-title">
            <h4 class="title">Never Miss News</h4>
        </div>
        <div class="sidebar-social text-center mt-35">
            <ul>
                <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                <li><a href="#"><i class="fab fa-behance"></i></a></li>
                <li><a href="#"><i class="fab fa-linkedin-in"></i></a></li>
                <li><a href="#"><i class="fab fa-pinterest"></i></a></li>
            </ul>
        </div>
    </div>
    <div class="blog-sidebar-item mt-30">
        <div class="sidebar-title">
            <h4 class="title">Twitter Feeds</h4>
        </div>
        <div class="sidebar-twitter-feeds mt-35">
            <div class="sidebar-twitter-feeds-item">
                <ul>
                    <li><a href="#">Rescue - #Gutenberg ready @ wordpress</a></li>
                    <li><a href="#">Theme for Creative Bloggers available on</a></li>
                    <li><a href="#">@ ThemeForest https://t.co/2r1POjOjgV</a></li>
                    <li><a href="#">C… https://t.co/rDAnPyClu1</a></li>
                </ul>
                <span>November 25, 2018</span>
                <i class="fab fa-twitter"></i>
            </div>
            <div class="sidebar-twitter-feeds-item">
                <ul>
                    <li><a href="#">Rescue - #Gutenberg ready @ wordpress</a></li>
                    <li><a href="#">Theme for Creative Bloggers available on</a></li>
                    <li><a href="#">@ ThemeForest https://t.co/2r1POjOjgV</a></li>
                    <li><a href="#">C… https://t.co/rDAnPyClu1</a></li>
                </ul>
                <span>November 25, 2018</span>
                <i class="fab fa-twitter"></i>
            </div>
            <div class="sidebar-twitter-feeds-item">
                <ul>
                    <li><a href="#">Rescue - #Gutenberg ready @ wordpress</a></li>
                    <li><a href="#">Theme for Creative Bloggers available on</a></li>
                    <li><a href="#">@ ThemeForest https://t.co/2r1POjOjgV</a></li>
                    <li><a href="#">C… https://t.co/rDAnPyClu1</a></li>
                </ul>
                <span>November 25, 2018</span>
                <i class="fab fa-twitter"></i>
            </div>
        </div>
    </div>
    <div class="blog-sidebar-item mt-30">
        <div class="sidebar-title">
            <h4 class="title">Instagram Feeds</h4>
        </div>
        <div class="sidebar-instagram mt-35">
            <ul>
                <li><a href="#"><img src="assets/images/instagram-1.jpg" alt=""></a></li>
                <li><a href="#"><img src="assets/images/instagram-2.jpg" alt=""></a></li>
                <li><a href="#"><img src="assets/images/instagram-3.jpg" alt=""></a></li>
            </ul>
            <ul>
                <li><a href="#"><img src="assets/images/instagram-4.jpg" alt=""></a></li>
                <li><a href="#"><img src="assets/images/instagram-5.jpg" alt=""></a></li>
                <li><a href="#"><img src="assets/images/instagram-6.jpg" alt=""></a></li>
            </ul>
            <ul>
                <li><a href="#"><img src="assets/images/instagram-7.jpg" alt=""></a></li>
                <li><a href="#"><img src="assets/images/instagram-8.jpg" alt=""></a></li>
                <li><a href="#"><img src="assets/images/instagram-9.jpg" alt=""></a></li>
            </ul>
        </div>
    </div>
    <div class="blog-sidebar-item mt-30">
        <div class="sidebar-title">
            <h4 class="title">Tags</h4>
        </div>
        <div class="sidebar-tags mt-35">
            <ul>
                <li><a routerLink='/blog-detail'>Popular</a></li>
                <li><a routerLink='/blog-detail'>desgin</a></li>
                <li><a routerLink='/blog-detail'>ux</a></li>
            </ul>
            <ul>
                <li><a routerLink='/blog-detail'>usability</a></li>
                <li><a routerLink='/blog-detail'>develop</a></li>
                <li><a routerLink='/blog-detail'>icon</a></li>
            </ul>
            <ul>
                <li><a routerLink='/blog-detail'>business</a></li>
                <li><a routerLink='/blog-detail'>consult</a></li>
                <li><a routerLink='/blog-detail'>kit</a></li>
            </ul>
            <ul>
                <li><a routerLink='/blog-detail'>keyboard</a></li>
                <li><a routerLink='/blog-detail'>mouse</a></li>
                <li><a routerLink='/blog-detail'>tech</a></li>
            </ul>
        </div>
    </div>
    <div class="blog-sidebar-add mt-30">
        <img src="assets/images/sidebar-ad-2.jpg" alt="add">
        <div class="add-content">
            <span>350x600</span>
            <h5 class="title">Add Banner</h5>
        </div>
    </div> -->
</div>
